import React, { useEffect, useState } from "react";
import "./Calendar.css";
import { FaCircleXmark, FaCircleCheck } from "react-icons/fa6";
import { FaCircleDot, FaCirclePlus } from "react-icons/fa6";

import {
  HEADER_COLOR,
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  TERTIARY_COLOR,
} from "../constants/theme";
import moment from "moment/moment";
import { getDrScheduleByPatientIdAndDateRange } from "../services/drSchedule/drSchedule.service";
import Loader from "../components/Loader";
import { useNavigate } from "react-router";

const Calendar = ({ events }) => {
  const email = sessionStorage.getItem("email");
  const patientId = sessionStorage.getItem("patientId");

  const [currentDate, setCurrentDate] = useState(new Date());
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const firstDayOfMonth = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const [eventsLoading, setEventsLoading] = useState(false);
  const [eventDates, setEventDates] = useState([]);

  const fetchEvents = async (start) => {
    try {
      setEventDates([]);
      setEventsLoading(true);
      let startDate = start;

      let endDate = moment(startDate)
        .clone()
        .endOf("month")
        .format("YYYY-MM-DD");
      startDate = moment(startDate).format("YYYY-MM-DD");

      const res = await getDrScheduleByPatientIdAndDateRange(
        email,
        patientId,
        startDate,
        endDate
      );
      if (res.status === 200 && res.data.status === 200) {
        res.data.data.sort(
          (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
        );

        let resDataFinal = res.data.data.map((item) => {
          return {
            ...item,
            day: parseInt(
              item?.date?.split("-")[item?.date?.split("-").length - 1]
            ),
          };
        });
        setEventDates(resDataFinal);
        setEventsLoading(false);
      }
    } catch (error) {
      // toast.error(error?.data?.message || error?.message);
      // setEventDates([])
      setEventsLoading(false);
      return;
    }
  };

  const handlePrevMonth = async () => {
    let curr = new Date(year, month - 1, 1);
    setCurrentDate(curr);

    fetchEvents(curr);
  };
  const handleNextMonth = () => {
    let curr = new Date(year, month + 1, 1);
    setCurrentDate(curr);

    fetchEvents(curr);
  };

  const generateDays = () => {
    const daysArray = [];
    for (let i = 0; i < firstDayOfMonth; i++) {
      daysArray.push(null);
    }
    for (let i = 1; i <= daysInMonth; i++) {
      daysArray.push(i);
    }
    return daysArray;
  };

  const [days] = useState(generateDays());
  const navigate = useNavigate();

  const explanationData = [
    {
      icon: (
        <FaCirclePlus
          style={{
            height: "10px",
            width: "10px",
            color: "#fae5ff",
            overflow: "visible",
          }}
        />
      ),
      desc: "New Appointment",
    },
    {
      icon: (
        <FaCircleCheck
          style={{
            height: "10px",
            width: "10px",
            color: "#00bf63",
            overflow: "visible",
          }}
        />
      ),
      desc: "Appointment Confirmed",
    },
    {
      icon: (
        <FaCircleDot
          style={{
            height: "10px",
            width: "10px",
            color: "#0cc0df",
            overflow: "visible",
          }}
        />
      ),
      desc: "Aligner Replacement",
    },
    {
      icon: (
        <FaCircleXmark
          style={{
            height: "10px",
            width: "10px",
            color: "red",
            overflow: "visible",
          }}
        />
      ),
      desc: "Appointment Cancelled",
    },
  ];

  const [screenWidth, setScreenWidth] = useState(0);

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  useEffect(() => {
    const t = moment();
    const y = t.year();

    const m = t.month();

    let start = new Date(new Date(y, m, 1));
    fetchEvents(start);
  }, []);

  return (
    <div
      className="container-fluid p-0 position-relative"
      style={{
        overflow: "hidden",
      }}
    >
      <div
        className="position-relative"
        style={{
          minHeight: "100vh",
          zIndex: "20",
          padding: "0px 10px",
        }}
      >
        <div
          className={`row w-100 mx-auto flex-column align-items-center justify-content-start`}
          style={{
            backgroundColor: "rgb(255, 255, 255)",
            padding: "13px 13px 32px 13px",
            borderRadius: "18px",
            minHeight: "calc(100vh - 80px)",
          }}
        >
          {/* <h4
            className="text-center p-0 mt-2"
            style={{
              color: HEADER_COLOR,
            }}
          >
            Calendar
          </h4>

          <hr /> */}
          {!eventsLoading && (
            <div className="calendar" style={{ fontSize: "12px" }}>
              <div className="calendar-header">
                <button
                  className="btn"
                  style={{
                    backgroundColor: PRIMARY_COLOR,
                    color: TERTIARY_COLOR,
                  }}
                  onClick={handlePrevMonth}
                >
                  &lt;
                </button>
                <h5 style={{ color: PRIMARY_COLOR }}>
                  {currentDate.toLocaleString("default", { month: "long" })}{" "}
                  {year}
                </h5>
                <button
                  className="btn"
                  style={{
                    backgroundColor: PRIMARY_COLOR,
                    color: TERTIARY_COLOR,
                  }}
                  onClick={handleNextMonth}
                >
                  &gt;
                </button>
              </div>
              <div className="calendar-grid">
                {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map(
                  (day) => (
                    <div
                      key={day}
                      className="calendar-day-name"
                      style={{ color: SECONDARY_COLOR }}
                    >
                      {day}
                    </div>
                  )
                )}
                {days.map((day, index) => {
                  let mapEvent = eventDates.filter((item) => item.day === day);
                  let cancel = false;
                  let schedule = false;
                  if (mapEvent.length > 0) {
                    mapEvent.map((map) => {
                      if (map?.current_status === "Scheduled") {
                        schedule = true;
                      } else if (map?.current_status === "Canceled") {
                        cancel = true;
                      }
                      return map;
                    });
                  }
                  // Get today's date
                  const today = new Date();
                  const todayDay = today.getDate();
                  const todayMonth = today.getMonth(); // 0 = January, 1 = February, etc.
                  const todayYear = today.getFullYear();

                  // Check if the current day matches today's date, month, and year
                  const isToday =
                    day === todayDay &&
                    currentDate.getMonth() === todayMonth &&
                    currentDate.getFullYear() === todayYear;
                  const appointmentDate = `${currentDate.getFullYear()}-${
                    currentDate.getMonth() + 1
                  }-${day}`;

                  return (
                    <div
                      key={index}
                      className={`calendar-day border`}
                      onClick={() => {
                        if (mapEvent && mapEvent.length > 0) {
                          let id = mapEvent.find(
                            (item) => item.current_status === "Scheduled"
                          )?.schedule_id;
                          if (!id) {
                            id = mapEvent.find(
                              (item) => item.current_status === "Canceled"
                            )?.schedule_id;
                          }
                          if (!id) {
                            id = mapEvent[0]?.schedule_id;
                          }
                          sessionStorage.setItem("appointmentId", id);
                          navigate(`/appointment-view`);
                        } else {
                          sessionStorage.setItem(
                            "appointmentDate",
                            appointmentDate
                          );
                          navigate("/appointment");
                        }
                      }}
                    >
                      {day && (
                        <button
                          className="day-button d-flex flex-column justify-content-center align-content-center align-items-center"
                          style={{
                            color: isToday ? TERTIARY_COLOR : SECONDARY_COLOR,
                            backgroundColor: isToday ? PRIMARY_COLOR : "",
                          }}
                        >
                          {day}
                          {schedule && (
                            <FaCircleCheck
                              color="#00bf63"
                              style={{
                                height: "50%",
                                width: "50%",

                                overflow: "visible",
                              }}
                            />
                          )}
                          {cancel && (
                            <FaCircleXmark
                              color="red"
                              style={{
                                height: "50%",
                                width: "50%",
                                color: "red",
                                overflow: "visible",
                              }}
                            />
                          )}

                          <FaCirclePlus
                            style={{
                              height: "50%",
                              width: "50%",
                              color: "#fae5ff",
                              overflow: "visible",
                            }}
                          />
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          <div
            className="row w-100 mx-auto mt-2 align-items-center justify-content-center"
            style={{
              color: "rgb(110, 121, 125)",
              fontSize: "9px",
            }}
          >
            {explanationData.map((item) => (
              <div className="col-auto p-0 mx-2" key={item.desc}>
                <div
                  className="d-flex align-items-center justify-content-start"
                  style={{
                    gap: "5px",
                  }}
                >
                  {item.icon}
                  <div
                    className=""
                    style={{
                      width: "100px",
                    }}
                  >
                    {item.desc}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div
            className={`mt-2 ${screenWidth > 620 ? "col-8" : "col-auto"} p-0`}
          >
            <div
              className="row w-100 mx-auto mt-2 flex-column justify-content-between align-items-start"
              style={{
                color: "rgb(110, 121, 125)",
                gap: "25px",
                minWidth: "245px",
              }}
            >
              {eventsLoading && <Loader />}
              {!eventsLoading &&
                eventDates &&
                eventDates.length > 0 &&
                eventDates.map((event, index) => {
                  if (event.type !== "new") {
                    return (
                      <div className="col-12 p-0" key={event._id}>
                        <div
                          className={`row w-100 mx-auto align-items-center justify-content-${
                            screenWidth > 620 ? "between" : "start"
                          }`}
                          style={{
                            gap: screenWidth >= 576 ? "23px" : "7px",
                          }}
                        >
                          <div className="d-flex col-auto px-0 gap-md-4 gap-2">
                            <div className="col-auto p-0 position-relative">
                              {index !== eventDates.length - 1 && (
                                <div
                                  className="position-absolute"
                                  style={{
                                    width: "0.8px",
                                    height: "22px",
                                    backgroundColor: "rgb(176, 176, 176)",
                                    bottom: "0",
                                    left: "50%",
                                    transform:
                                      "translateY(112%) translateX(0%)",
                                  }}
                                ></div>
                              )}
                              <div
                                className="d-flex align-items-center justify-content-center"
                                style={{
                                  height: "21px",
                                  width: "21px",
                                }}
                              >
                                {event?.current_status === "Scheduled" ? (
                                  <FaCircleCheck color="#00bf63" />
                                ) : event?.current_status === "Canceled" ? (
                                  <FaCircleXmark color="red" />
                                ) : null}
                              </div>
                            </div>

                            <div
                              className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                              style={{
                                lineHeight: "1",
                                minWidth: "45px",
                                gap: "3px",
                                color: "rgb(166, 166, 166)",
                              }}
                            >
                              <div
                                className="p-0"
                                style={{
                                  fontSize: "12px",
                                }}
                              >
                                {moment(event.date).format("DD MMM")}
                              </div>
                              <div
                                className="col-auto p-0"
                                style={{
                                  fontSize: "8.5px",
                                }}
                              >
                                {event.start_time_clock} -{" "}
                                {event.end_time_clock}
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${
                              screenWidth > 620 ? "col-5" : "col"
                            } p-0`}
                            style={{
                              fontSize: "12px",
                            }}
                          >
                            <div>Appointment for {event.service_type}</div>
                            <div
                              className=""
                              style={{
                                fontSize: "8.5px",
                              }}
                            >
                              {event.current_status}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  } else {
                    return null;
                  }
                })}

              {!eventsLoading && eventDates && eventDates.length === 0 && (
                <h6>No appointments/tasks in current month!</h6>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calendar;
